import {BASE} from "../services/urls";

export const API_GET_SESSION_TRANSACTIONS = async ({ queryKey }) => {

    const token = localStorage.getItem("x-imperso") || localStorage.getItem('x-access-token')
    const { limit, page } = queryKey[1];

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token
        }
    };

    const response = await fetch(`${BASE}/transactions/sessions?page=${page}&limit=${limit}`, options);
    if (!response.ok) throw new Error(JSON.stringify(response.text()))
    return response.json()
}

export const API_GET_TRANSACTION = async ({ queryKey }) => {

    const token = localStorage.getItem('x-access-token') || localStorage.getItem("x-imperso")
    const { limit, page, id } = queryKey[1];

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token
        }
    };

    const response = await fetch(`${BASE}/transactions/?id=${id}&page=${page}&limit=${limit}`, options);
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Request failed');
    }

    return response.json()
}
export const API_PUT_DESCRIPTION_TRANSACTION = async ({ description, id, page, limit }) => {

    const token = localStorage.getItem('x-access-token')

    const options: any = {
        method: 'PUT',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token
        },
        body: JSON.stringify({
            "description": description,
        })
    };

    const response = await fetch(`${BASE}/transactions/?id=${id}&page=${page}&limit=${limit}`, options);
    if (!response.ok) throw new Error(JSON.stringify(response.text()))
    return response.json()
}

export const API_GET_TRANSACTION_COMMENTS_BY_TX = async ({ queryKey }) => {

    const token = localStorage.getItem('x-access-token') || localStorage.getItem("x-imperso")
    const { limit, page, id } = queryKey[1];

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token
        }
    };

    const response = await fetch(`${BASE}/transactions/comments/by_transaction/?id=${id}&page=${page}&limit=${limit}`, options);
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Request failed');
    }

    return response.json()
}

export const API_ADD_TRANSACTION_COMMENTS = async ({ id, comment }) => {

    const token = localStorage.getItem('x-access-token') || localStorage.getItem("x-imperso")
    

     const options: any = {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token
        },
        body: JSON.stringify({
            "id": id,
            "comment": comment
        })
    };

    const response = await fetch(`${BASE}/transactions/comments`, options);

    if (!response.ok) throw new Error(JSON.stringify(response.text()))
    return response.json()
}

